import { useNavigate } from "react-router-dom"
import { FullscreenDialog } from "../components/dialog/FullscreenDialog"
import { WhatsNew } from "./WhatsNew"
import { useFeatureEnabled } from "../hooks/useFeatureToggles"

/**
 * WhatsNewDialog - Wrapper component that renders WhatsNew in a fullscreen dialog
 * Used as a nested route within Dashboard to prevent section reloads
 */
export const WhatsNewDialog = () => {
  const navigate = useNavigate()
  const isWhatsNewEnabled = useFeatureEnabled("whats_new")

  const handleClose = () => {
    navigate("/")
  }

  // If feature is disabled, redirect to home
  if (!isWhatsNewEnabled) {
    navigate("/", { replace: true })
    return null
  }

  return (
    <FullscreenDialog open={true} onClose={handleClose} title="What's New">
      <WhatsNew />
    </FullscreenDialog>
  )
}
